export function money(cents, currency = 'CAD') {
  const amount = (Number(cents) || 0) / 100
  try {
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency || 'CAD' }).format(amount)
  } catch (error) {
    return `${amount.toFixed(2)} ${currency || ''}`.trim()
  }
}

export function moneyList(rows) {
  if (!rows || !rows.length) return '—'
  return rows.map(row => money(row.grossCents, row.currency)).join(' · ')
}

export const VISIBILITY_LABELS = {
  public: 'Public',
  private: 'Private link',
  hidden: 'Hidden from public',
  draft: 'Draft',
  cancelled: 'Cancelled',
}

export function visibilityVariant(value) {
  if (value === 'public') return 'success'
  if (value === 'hidden') return 'danger'
  if (value === 'private') return 'info'
  if (value === 'cancelled') return 'warning'
  return 'secondary'
}
